import useTwinTranslation from '../../utils/hooks/useTwinTranslation'
import { TwinDictionary } from '../../utils/globals/dictionary'
import { InputHidden } from '../../forms/Input'
import { CustomSelectWithSearchBarNotInFilteredItems } from '../../forms/CustomSelect'
import TwinIcon from '../TwinIcon'
import { faXmark } from '@fortawesome/pro-light-svg-icons'


interface TwinTagSelectorProps {
    readOnly?: boolean
    selectedTags: string[]
    dictTags: TwinDictionary
    className?: string
    addTag?: (TagId: number)=>void
    removeTag?: (posArr: number)=>void
 }

const TwinTagSelector: React.FC<TwinTagSelectorProps> = ({ dictTags, selectedTags, addTag, removeTag, className, readOnly = false }) => {
    const {t} = useTwinTranslation()
    const renderThis: JSX.Element[] = []
    if(selectedTags?.length){
        for (const key in selectedTags) {
            const TagId = selectedTags?.[key]
            if (dictTags?.[TagId]) {
                renderThis.push(<RenderTag key={key} tag={dictTags?.[TagId]} posArr={parseInt(key)} removeTag={removeTag} readOnly={readOnly} />)
            }
        }
    } else{
        renderThis.push(<span key='noTags' className='regular12 py-5'>{t('noTags', 'Sin etiquetas')}</span>)
    }
    if(readOnly){
        return (
            <div className='flex flex-wrap content-start gap-10 mt-10'>
                {renderThis}
            </div>
        )
    }
    return (
        <div>
            <CustomSelectWithSearchBarNotInFilteredItems className={className} label={t('tags', 'etiquetas')} items={dictTags || {}} excludeItems={selectedTags || []} fieldName='name' onChange={addTag}/>
            <div className={'mt-20 min-h-50 rounded-xl border border-gray-97 flex flex-wrap content-start flex-auto px-10 py-10 gap-10 ' + (!readOnly? 'flex-auto': '')}>
                {renderThis}
            </div>
            <InputHidden name='tagsForParse' value={selectedTags?.join(';')} />
        </div>
    )
}

interface RenderTagProps {
    posArr: number
    tag: TwinDictionary
    removeTag?: (posArr: number)=> void
    readOnly: boolean
}

const RenderTag: React.FC<RenderTagProps> = ({ tag, posArr, removeTag, readOnly }) => {
    return (
        <div className='flex items-center bg-gray-F7 px-10 py-5'>
            <div className={'rounded-full h-10 w-10 mr-5 border border-gray-D6 '} style={{ backgroundColor: tag?.color }} />
            <span>{tag?.name}</span>
            {readOnly ? null : <TwinIcon className='ml-10 cursor-pointer hover:text-red-BA' icon={faXmark} onClick={()=>removeTag?.(posArr)} />}
        </div>
    )
}


export default TwinTagSelector